{
  "required": "%{field}を入力してください",
	"email": "メールアドレスの形式が不正です",
	"password": "パスワードは、半角英小文字大文字、数字を含む8文字以上で入力してください",
	"username": "ユーザ名は、半角英小文字大文字、数字を入力してください",
	"username duplicated": "入力されたユーザ名は使用できません",
	"email duplicated": "入力されたメールアドレスは使用できません",
	"identifier not found": "入力されたユーザ名またはメールアドレスは登録されていません"
}